import React from "react";
import { Redirect, Route } from "react-router";

const ProcessingRoute = ({ key, auth, verified, ...route }) => {
  if (!auth || (auth && !verified)) {
    // console.log("%c RENDER VERIFYING ROUTE", "font-size:30px;color:green;");
    return <Route key={key} {...route} />;
  } else if (auth && verified) {
    // console.log("%c REDIRECT TO HOME", "font-size:30px;color:red;");
    return <Redirect to="/hosts" />;
  } else {
    // console.log("%c DEFAULT REDIRECT", "font-size:30px;color:red;");
    return <Redirect to="/pages/auth/login" />;
  }
};

export default ProcessingRoute;
